import Api from '@common/services/api';

export const toggleArchive = async (orgId: string, conversationId: string, shouldArchive: boolean) => {
  return Api.post(`/v3/organisations/${orgId}/conversations/${conversationId}/${shouldArchive ? 'archive' : 'unarchive'}`);
};
